// imports
import { Controller, useFormContext } from 'react-hook-form';
import { FC } from 'react';
// components
import SandComponentSelect from 'components/common/simpleSelectors/ServingSize';
// interfaces
import { ServingSizeSelectorProps } from 'interfaces';

const ServingSizeSelector: FC<ServingSizeSelectorProps> = ({ name, title, handleChange, ...rest }) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => {
        const { name, onBlur, onChange, value } = field;
        const { error } = fieldState;
        const { message } = error || {};

        return (
          <SandComponentSelect
            name={name}
            title={title}
            value={value}
            onBlur={onBlur}
            helperText={message}
            error={Boolean(message)}
            handleChange={(val) => {
              onChange(val);
              handleChange && handleChange(val);
            }}
            {...rest}
          />
        );
      }}
    />
  );
};

export default ServingSizeSelector;
